import { c as _c } from "react/compiler-runtime";
import type { PrV2MarkerDetectedAgent } from '@/lib/pr-v2/types';
import { AiAttributionToolRow } from './ai-attribution-tool-row';
import { isUnknownModel } from './ai-attribution-utils';
import { getModelIcon, getToolIcon } from '@/components/icons/ai-providers';
type AiAttributionDetectedAgentsListProps = {
  agents: PrV2MarkerDetectedAgent[];
  testId: string;
};

/**
 * Marker-detected agents. Rows carry no line counts on purpose: markers only
 * say an agent was involved, never how much it wrote.
 */
export function AiAttributionDetectedAgentsList(t0) {
  const $ = _c(5);
  const {
    agents,
    testId
  } = t0;
  let t1;
  if ($[0] !== agents) {
    t1 = agents.map(_temp);
    $[0] = agents;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== testId) {
    t2 = <div data-testid={testId} className="space-y-1.5">{t1}</div>;
    $[2] = t1;
    $[3] = testId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(t0) {
  const {
    agentId,
    model,
    band
  } = t0;
  const hasModel = model !== null && !isUnknownModel(model);
  return <AiAttributionToolRow key={agentId} tool={agentId} model={model} percent={null} tag={band === "certain" ? null : "likely"} ToolIcon={getToolIcon(agentId)} ModelIcon={hasModel ? getModelIcon(model) : null} />;
}